import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider } from './auth/AuthContext';
import { App } from './App';
import './index.css';

const klient = new QueryClient({
  defaultOptions: {
    queries: {
      // Kilka osób pracuje jednocześnie — dane starzeją się szybko, ale nie
      // ma sensu odpytywać serwera przy każdym przełączeniu zakładki.
      staleTime: 10_000,
      retry: (proba, blad) => {
        // Brak sesji i brak uprawnień nie naprawią się przez powtórzenie.
        const status = (blad as { status?: number })?.status;
        if (status === 401 || status === 403) return false;
        return proba < 2;
      },
    },
  },
});

/**
 * Service worker rejestrujemy tylko w wersji zbudowanej. W trybie
 * deweloperskim przechwytywałby moduły Vite i odświeżanie na gorąco
 * pokazywałoby stary kod — godzina szukania błędu, którego nie ma.
 */
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch((e) => {
      // Brak service workera to mniej wygody, nie awaria — aplikacja działa dalej.
      console.warn('Nie udało się zarejestrować service workera:', e);
    });
  });
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={klient}>
      <AuthProvider>
        <App />
      </AuthProvider>
    </QueryClientProvider>
  </StrictMode>,
);
